import { Component, signal } from '@angular/core';
import { HasPermissionDirective } from '@core/directives/has-permission.directive';
import { TranslateModule } from '@ngx-translate/core';
import { BaseComponent } from '@shared/components/base.component';
import { ContentContainerComponent } from '@shared/components/content-container/content-container.component';
import { GlobalTemplatesComponent } from './global-templates/global-templates.component';
import { SettingsSidebarComponent } from './settings-sidebar/settings-sidebar.component';
import { TSettingsTab } from './settings-sidebar/settings-sidebar.interface';
import { UserManagementComponent } from './user-management/user-management.component';

@Component({
  imports: [
    TranslateModule,
    SettingsSidebarComponent,
    UserManagementComponent,
    GlobalTemplatesComponent,
    ContentContainerComponent,
    HasPermissionDirective,
  ],
  selector: 'app-settings',
  templateUrl: './settings.component.html',
})
export class SettingsComponent extends BaseComponent {
  public readonly activeTab = signal<TSettingsTab>(this.getDefaultTab());

  public onTabSelected(tab: TSettingsTab): void {
    this.activeTab.set(tab);
  }

  /** Mirrors the settings sidebar's own per-tab visibility gate (see
   * SettingsSidebarComponent.items, and the matching `*hasPermissionGroups` guards in this
   * component's template) - kept in sync so the tab this defaults to is never one the sidebar, or
   * the template's own content gate, would hide. Falling back to 'globalTemplates' is safe even
   * when `canSeeUserManagement` is false: the `/account-panel` route guard (app.routes.ts) only
   * admits a user who holds `userGroupDeleteMemberOwn` or `campaignCreate`, so failing the first
   * check here guarantees the second is true. */
  private getDefaultTab(): TSettingsTab {
    const canSeeUserManagement = this.permissionService.hasPermission(this.EPermissions.userGroupDeleteMemberOwn);

    if (canSeeUserManagement) {
      return 'userManagement';
    }

    return 'globalTemplates';
  }
}
